//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from "vue";
import YmapPlugin, { loadYmap } from 'vue-yandex-maps';
import { AppMixin } from '~/node_modules/sitis-nuxt/lib/mixins/index';

const settings = {
  apiKey: process.env.yandexMapApiKey,
  lang: "ru_RU",
  coordorder: "latlong",
  version: "2.1",
};
Vue.use(YmapPlugin, settings);

export default {
  name: "SalonSelection",
  data: function () {
    return {
      cities: [],
      yandexMapCoords: [56.838011, 60.597465],
      salons: [],
      searchStore: "",

      activeCity: 1,
      activeShop: -1,
    };
  },
  props: {
    activeServce: {
      type: Number,
      required: true,
    },
    activeSalon: {
      type: [String, Number],
    },
    activeAge: {
      type: [String, Number],
    },
  },
  components: {
    yandexMap: () => import("vue-yandex-maps"),
  },
  computed: {
    getStores: function () {
      return this.salons.filter((t) => {
        if (
          t.city_id === this.activeCity &&
          t.address.toLowerCase().indexOf(this.searchStore.toLowerCase()) > -1
        ) {
          return t;
        }
      });
    },
  },
  watch: {
    activeServce: async function() {
      await this.yandexMapDestroy();
      this.yandexMapSetMarkers();
    },
    activeSalon: async function() {
      await this.yandexMapDestroy();
      this.yandexMapSetMarkers();
    },
    activeCity: async function() {
      await this.yandexMapDestroy();
      this.yandexMapSetMarkers();
    },
    activeShop: async function() {
      await this.yandexMapDestroy();
      this.yandexMapSetMarkers();
    },
  },
  mixins: [
    AppMixin
  ],
  async mounted() {
    const filterAge = Boolean(this.activeAge === "19") ? "filter[for_not_children]=1" : `filter[for_children_${(this.activeAge || "").replace("-", "_")}]=1`;
    let { data: salons } = await this.$api.agent.transport.get(`stores?${filterAge}&filter[service_id]=${this.activeServce}`);
    this.salons = salons;
    let cities = [];
    this.salons.map((shop) => {
      if (!Boolean(cities.find((t) => t.id === shop.city_id))) {
        cities.push({
          id: shop.city_id,
          city_name: shop.city_name,
        });
      }
    });
    this.cities = cities;

    const activeCityName = this.appCfg?.city?.model?.name || "Екатеринбург";
    let activeCityId = this.cities.find((t) => t?.city_name === activeCityName)?.id || 1;

    this.activeCity = activeCityId;

    // if (this.activeSalon) {
    //   this.activeShop = this.activeSalon;
    //   this.activeCity = Boolean(this.activeSalon === -1) ? 1 : this.salons.find((salon) => salon.id === this.activeSalon)?.city_id;
    //
    //   if (this.activeCity && this.activeSalon !== -1) {
    //     this.onChange(this.activeShop);
    //   }
    // }

    await this.yandexMapInit();
  },
  methods: {

    // Инициализация и удаление карты
    yandexMapInit: async function () {
      await loadYmap({ ...settings, debug: true });

      if (!document.getElementById('yandex-map')) {
        return null
      }

      this.yandexMap = new ymaps.Map('yandex-map', {
        center: this.yandexMapCoords,
        zoom: 12,
        behaviors: ['drag', 'dblClickZoom', 'multiTouch']
      }, {
        maxZoom: 17
      });

      this.yandexMapSetMarkers();
    },
    yandexMapSetMarkers: function () {

      if (!this.yandexMap || this.getStores.length <= 0) {
        return null
      }

      const yandexMap = this.yandexMap;
      const self = this;

      let activePoint = null;
      this.getStores.map((store) => {
        // берем активную точку, если она выбрана
        if (this.activeShop === store.id) {
          activePoint = store;
        }
        let MyIconContentLayout = ymaps.templateLayoutFactory.createClass(`<div class="store-map-pointer ${Boolean(this.activeShop === store.id || this.getStores.length === 1) ? ' store-map-pointer--active' : ''}"><span>${store.address}</span></div>`);
        let myPlacemarkWithContent = new ymaps.Placemark([store.lat, store.lon], {}, {
          iconLayout: "default#imageWithContent",
          iconImageHref: '',
          content: "",
          contentLayout: "",
          imageSize: [60, 60],
          imageOffset: [-30, -30],
          contentOffset: [30, 20],
          iconContentLayout: MyIconContentLayout,
        })
        myPlacemarkWithContent.events.add('click', function () {
          self.setStore(store.id);
        });

        yandexMap.geoObjects.add(myPlacemarkWithContent);
      });

      // Установка границ карты и перемещение центра, если выбрана точка
      (async () => {
        await yandexMap.setBounds(yandexMap.geoObjects.getBounds(), {
          checkZoomRange: true,
          zoomMargin: [160, 0]
        });
        if (activePoint !== null) {
          await yandexMap.panTo([activePoint.lat, activePoint.lon]);
        }
      })();
    },
    yandexMapDestroy: async function () {
      if (!this.yandexMap) {
        return null
      }

      await this.yandexMap?.geoObjects?.removeAll();
    },

    onChange: function (salon) {
      this.$emit("change", { name: "salon", value: salon });
    },

    setCity: function (id) {
      this.activeShop = -1;
      this.activeCity = id;
    },
    setStore: function (id) {
      this.activeShop = null;
      this.activeShop = id;
      this.onScrollActiveShop(id);
    },
    onScrollActiveShop(shopId) {
      const container = document.getElementById(`container-shops`);
      const activeShop = document.getElementById(`store${shopId}`);
      const containerScrollPositionTop = container.offsetTop;
      const itemScrollPositionTop = activeShop.offsetTop;

      this.$refs.refContainerShops.scrollTo({
        top: itemScrollPositionTop - containerScrollPositionTop,
        behavior: "smooth",
      });
    },
    onChangeSearch: function ({ target }) {
      this.searchStore = target.value;
    },

    getIcon: function (store) {
      const isActive = Boolean(this.activeShop === store.id);
      const className = `store-map-pointer${
        isActive ? " store-map-pointer--active" : ""
      }`;

      return {
        layout: "default#imageWithContent",
        imageHref: "",
        imageSize: [60, 60],
        imageOffset: [-30, -30],
        content: "",
        contentOffset: [30, 20],
        contentLayout: `<div class="${className}"><span>${store.address}</span></div>`,
      };
    },
  },
};
